import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".userName-library--PoDnV {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.flex-library--MGB8K {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n.flex-library--MGB8K .grow-library--rchb- {\n  flex-grow: 1;\n}";
var styles = {"userName":"userName-library--PoDnV","flex":"flex-library--MGB8K","grow":"grow-library--rchb-"};
styleInject(css_248z);

export { styles as default };
